'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.cleanSpaceForInnerHtml = cleanSpaceForInnerHtml;
exports.createElement = createElement;
exports.removeElement = removeElement;
exports.insertBefore = insertBefore;
exports.insertAfter = insertAfter;
exports.contains = contains;
exports.isElement = isElement;
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.getViewportWidth = getViewportWidth;
exports.getViewportHeight = getViewportHeight;
exports.getOffsetAwayFromDocument = getOffsetAwayFromDocument;
exports.getAbsRelativeLayout = getAbsRelativeLayout;
exports.getScrollLeft = getScrollLeft;
exports.getBoundingClientRect = getBoundingClientRect;
exports.getScrollTop = getScrollTop;

var _forEach = require('./forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _trim = require('./trim');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM 操作
 *
 */

function indexOfValidChars(str) {
  for (var i = 0, l = str.length; i < l; i++) {
    if (str[i] !== ' ' && str[i] !== '\n') {
      return i;
    }
  }
  return -1;
}

/**
 * 清理html字符串中的空格和换行符
 * @param {String} innerHtml
 * @return {String} innerHtml
 */
function cleanSpaceForInnerHtml(innerHtml) {
  var start = 0,
      newStr = '',
      diff = 0;
  for (var i = 0, l = innerHtml.length; i < l; i++) {
    if (innerHtml[i] === '\n') {
      var _str = innerHtml.substring(start, i + 1);
      if ((0, _trim.both)(_str).length) {
        if (!diff) {
          diff = indexOfValidChars(_str);
        }
        _str = _str.substring(diff, _str.length - 1);
        newStr += _str;
      }
      newStr += '\n';
      start = i;
    }
  }
  if (newStr.length > 2 && newStr[newStr.length - 1] === '\n') {
    newStr = newStr.substring(0, newStr.length - 1);
  }
  return newStr;
}

/**
 * 创建一个新元素
 * @param {String} innerHtml
 * @return {Element} element
 */
function createElement(innerHtml) {
  var element = document.createElement('div');
  element.innerHTML = innerHtml;
  element = element.children[0];
  return element;
}

/**
 * 删除指定的元素
 * @param {Node} element
 */
function removeElement(element) {
  var parentEl = element.parentNode;
  parentEl.removeChild(element);
}

/**
 * 在指定的元素前面追加新元素
 * @param {Node} newEl
 * @param {Node} targetEl
 */
function insertBefore(newEl, targetEl) {
  var parentEl = targetEl.parentNode;
  if (parentEl.firstChild == targetEl) {
    parentEl.appendChild(newEl);
  } else {
    parentEl.insertBefore(newEl, parentEl.firstChild);
  }
}

/**
 * 在指定的元素后面追加新元素
 * @param {Node} newEl
 * @param {Node} targetEl
 */
function insertAfter(newEl, targetEl) {
  var parentEl = targetEl.parentNode;
  if (parentEl.lastChild == targetEl) {
    parentEl.appendChild(newEl);
  } else {
    parentEl.insertBefore(newEl, targetEl.nextSibling);
  }
}

/**
 * 检测元素节点是不是另一个元素的子节点
 * @param {Object} parentNode
 * @param {Node} childNode
 * @return {Object} element
 */
function contains(parentNode, childNode) {
  if (parentNode.contains) {
    return parentNode != childNode && parentNode.contains(childNode);
  } else {
    return !!(parentNode.compareDocumentPosition(childNode) & 16);
  }
}

/**
 * 判断对象是否是一个 DOM元素
 * @param {Object} object
 * @return {Boolean}
 */
function isElement(object) {
  if ((typeof HTMLElement === 'undefined' ? 'undefined' : (0, _typeof3.default)(HTMLElement)) === 'object') {
    return object instanceof HTMLElement;
  } else {
    return object && (typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object' && object.nodeType === 1 && typeof object.nodeName === 'string';
  }
}

/**
 * 判断元素是否包含某个class
 * @param {Object} element
 * @param {String} className
 * @return {Boolean}
 */
function hasClass(element, className) {
  return !!element.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

/**
 * 为元素添加class
 * @param {Object} elements
 * @param {String} className
 */
function addClass(elements, className) {
  (0, _forEach2.default)(elements, function (element) {
    if (!hasClass(element, className)) {
      element.className += ' ' + className;
    }
  });
}

/**
 * 为元素移除class
 * @param {Object} elements
 * @param {String} className
 */
function removeClass(elements, className) {
  (0, _forEach2.default)(elements, function (element) {
    if (hasClass(element, className)) {
      element.className = element.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), ' ');
    }
  });
}

/**
 * 获取浏览器窗口的可视区域的宽度
 * @param {Document} dom
 * @return {Number} 宽度
 */
function getViewportWidth(dom) {
  !dom || (dom = document);
  return dom.documentElement.clientWidth || dom.body.clientWidth;
}

/**
 * 获取浏览器窗口的可视区域的高度
 * @param {Document} dom
 * @return {Number} 高度
 */
function getViewportHeight(dom) {
  !dom || (dom = document);
  return dom.documentElement.clientHeight || dom.body.clientHeight;
}

/**
 * 获取元素在页面上的偏移量
 * @param {Object} element 元素
 * @return {Object} position
 */
function getOffsetAwayFromDocument(element) {
  var top = 0,
      left = 0;
  if (element.getBoundingClientRect) {
    var rect = getBoundingClientRect(element);
    var body = document.body,
        docElem = document.documentElement;
    var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop,
        scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
    var clientTop = docElem.clientTop || body.clientTop,
        clientLeft = docElem.clientLeft || body.clientLeft;
    top = rect.top + scrollTop - clientTop;
    left = rect.left + scrollLeft - clientLeft;
    return {
      // Math.round 兼容火狐浏览器
      top: Math.round(top),
      left: Math.round(left)
    };
  } else {
    while (element) {
      top += element.offsetTop;
      left += element.offsetLeft;
      element = element.offsetParent;
    }
    return {
      top: top,
      left: left
    };
  }
}

/**
 * 获取浮动元素相对于目标元素的定位布局 居（上、右、下、左）
 * 设置贴近目标元素最近，能完整显示浮动元素的一个位置
 * 用于为浮动元素定位在目标元素身边
 * @param {Object} targetEl 目标元素
 * @param {Object} absEl 浮动元素
 * @param {String} direction 期望相对于目标元素的方向 默认为down
 * top、right、bottom、left
 * @return {Object}
 * direction：up、down、right、left
 */
function getAbsRelativeLayout(targetEl, absEl, direction) {
  if (!direction || ['up', 'right', 'down', 'left'].indexOf(direction) < 0) {
    direction = 'down';
  }
  var res = {};

  // 目标元素 在页面上的便偏移量
  var offsetAwayFromDocument = getOffsetAwayFromDocument(targetEl);
  // 目标元素 相对浏览器视窗的位置
  var boundingClientRect = getBoundingClientRect(targetEl);
  // 浏览器可视区域高宽
  var viewportOffset = {
    width: getViewportWidth(document),
    height: getViewportHeight(document)
  };
  boundingClientRect.bottom = viewportOffset.height - boundingClientRect.top - targetEl.offsetHeight;
  boundingClientRect.right = viewportOffset.width - boundingClientRect.left - targetEl.offsetWidth;
  // 页面文档真实高度 最小为屏幕高度
  var documentHeight = document.body.scrollHeight > window.screen.availHeight ? document.body.scrollHeight : window.screen.availHeight;

  if (direction === 'down' || direction === 'up') {
    // down 的可行性
    var _isDown = offsetAwayFromDocument.top + targetEl.offsetHeight + absEl.offsetHeight <= documentHeight;
    // up 的可行性
    var _isUp = offsetAwayFromDocument.top - absEl.offsetHeight >= 0;
    if (direction === 'down') {
      if (absEl.offsetHeight < boundingClientRect.bottom) {
        res.top = offsetAwayFromDocument.top + targetEl.offsetHeight;
        res.direction = 'down';
      } else {
        if (absEl.offsetHeight < boundingClientRect.top) {
          res.top = offsetAwayFromDocument.top - absEl.offsetHeight;
          res.direction = 'up';
        } else {
          if (_isDown) {
            res.top = offsetAwayFromDocument.top + targetEl.offsetHeight;
            res.direction = 'down';
          } else if (_isUp) {
            res.top = offsetAwayFromDocument.top - absEl.offsetHeight;
            res.direction = 'up';
          } else {
            res.top = offsetAwayFromDocument.top + targetEl.offsetHeight;
            res.direction = 'down';
          }
        }
      }
    } else {
      if (absEl.offsetHeight < boundingClientRect.top) {
        res.top = offsetAwayFromDocument.top - absEl.offsetHeight;
        res.direction = 'up';
      } else {
        if (absEl.offsetHeight < boundingClientRect.bottom) {
          res.top = offsetAwayFromDocument.top + targetEl.offsetHeight;
          res.direction = 'down';
        } else {
          if (_isUp) {
            res.top = offsetAwayFromDocument.top - absEl.offsetHeight;
            res.direction = 'up';
          } else if (_isDown) {
            res.top = offsetAwayFromDocument.top + targetEl.offsetHeight;
            res.direction = 'down';
          } else {
            res.top = offsetAwayFromDocument.top - absEl.offsetHeight;
            res.direction = 'up';
          }
        }
      }
    }
    if (offsetAwayFromDocument.left + (absEl.offsetWidth + targetEl.offsetWidth) / 2 > viewportOffset.width) {
      res.left = viewportOffset.width - absEl.offsetWidth;
    } else {
      res.left = offsetAwayFromDocument.left - (absEl.offsetWidth - targetEl.offsetWidth) / 2;
    }
  }
  if (direction === 'right' || direction === 'left') {
    // right 的可行性
    var _isDown2 = offsetAwayFromDocument.left + targetEl.offsetWidth + absEl.offsetWidth <= documentHeight;
    // left 的可行性
    var _isUp2 = offsetAwayFromDocument.left - absEl.offsetWidth >= 0;
    if (direction === 'right') {
      if (absEl.offsetWidth < boundingClientRect.bottom) {
        res.left = offsetAwayFromDocument.left + targetEl.offsetWidth;
        res.direction = 'right';
      } else {
        if (absEl.offsetWidth < boundingClientRect.left) {
          res.left = offsetAwayFromDocument.left - absEl.offsetWidth;
          res.direction = 'left';
        } else {
          if (_isDown2) {
            res.left = offsetAwayFromDocument.left + targetEl.offsetWidth;
            res.direction = 'right';
          } else if (_isUp2) {
            res.left = offsetAwayFromDocument.top - absEl.offsetWidth;
            res.direction = 'left';
          } else {
            res.left = offsetAwayFromDocument.top + targetEl.offsetWidth;
            res.direction = 'right';
          }
        }
      }
    } else {
      if (absEl.offsetWidth < boundingClientRect.left) {
        res.left = offsetAwayFromDocument.left - absEl.offsetWidth;
        res.direction = 'left';
      } else {
        if (absEl.offsetWidth < boundingClientRect.bottom) {
          res.left = offsetAwayFromDocument.left + targetEl.offsetWidth;
          res.direction = 'right';
        } else {
          if (_isUp2) {
            res.left = offsetAwayFromDocument.left - absEl.offsetWidth;
            res.direction = 'left';
          } else if (_isDown2) {
            res.left = offsetAwayFromDocument.left + targetEl.offsetWidth;
            res.direction = 'right';
          } else {
            res.left = offsetAwayFromDocument.left - absEl.offsetWidth;
            res.direction = 'left';
          }
        }
      }
    }
    if (offsetAwayFromDocument.top + (absEl.offsetHeight + targetEl.offsetHeight) / 2 > viewportOffset.height) {
      res.top = viewportOffset.top - absEl.offsetHeight;
    } else {
      res.top = offsetAwayFromDocument.top - (absEl.offsetHeight - targetEl.offsetHeight) / 2;
    }
  }

  return res;
}

/**
 * 获取浏览器窗口水平滚动条的位置
 * @param {Object} dom document
 * @return {Number} left
 */
function getScrollLeft(dom) {
  !dom || (dom = document);
  return dom.documentElement.scrollLeft || dom.body.scrollLeft;
}

/**
 * 获取页面中某个元素的左，上，右、下分别相对浏览器视窗的位置
 * @param {Object} element
 * @return {Object} top,lef,right,bottom,width,height
 * top：元素上边界距窗口最上面的距离
 * right：元素右边界距窗口最左边的距离
 * bottom：元素下边界距窗口最上面的距离
 * left：元素左边界距窗口最左边的距离
 * width：元素宽度
 * height：元素高度
 */
function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    width: rect.width || rect.right - rect.left,
    height: rect.height || rect.bottom - rect.top
  };
}

/**
 * 获取浏览器窗口垂直滚动条的位置
 * @param {Object} dom document
 * @return {Number} top
 */
function getScrollTop(dom) {
  !dom || (dom = document);
  return dom.documentElement.scrollTop || dom.body.scrollTop;
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/dom.js
// module id = 171
// module chunks = 0